import { generatePath } from 'react-router-dom';

import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the web tools menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 *  ldFlags: object
 *  order?: number
 *  isMobile: boolean
 * }} params
 * @returns {object}
 */
export function getWebToolsMenu(params) {
  const { businessEntityUuid, order } = params;

  return processMenu({
    title: 'Web Tools',
    icon: 'webpage-fill.svg',
    order,
    itemId: 'growth_overview',
    path: generatePath(ROUTES.marketingTools, { businessEntityUuid })
  });
}
